import { getSelfOrParentWithClassName } from "../../common/html";

export function initDisableContextMenu(el?: HTMLElement) {
	if (el) {
		el.addEventListener("contextmenu", (ev) => {
			disable(ev);
		});
		el.addEventListener("keyup", (ev) => {
			disable(ev);
		});
	} else {
		document.addEventListener("contextmenu", (ev) => {
			const target = ev.target as HTMLElement;
			if (getSelfOrParentWithClassName<HTMLElement>(target, "u-no-context-menu")) {
				disable(ev);
			}
		});
		document.addEventListener("keyup", (ev) => {
			const target = ev.target as HTMLElement;
			if (ev.key === "ContextMenu" && getSelfOrParentWithClassName<HTMLElement>(target, "u-no-context-menu")) {
				disable(ev);
			}
		});
	}
	const disable = (ev: Event) => {
		ev.preventDefault();
		ev.stopPropagation();
		return false;
	};
}
